import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.867 8.366-1.962-.388a5 5 0 0 0 0-1.956l1.962-.388a7 7 0 0 1 0 2.732M12.82 3.111l-1.662 1.112a5 5 0 0 0-1.382-1.382l1.112-1.662a7 7 0 0 1 1.932 1.932M8.366.133l-.388 1.962a5 5 0 0 0-1.956 0L5.634.133a7 7 0 0 1 2.732 0M3.111 1.18l1.112 1.662a5 5 0 0 0-1.382 1.382L1.179 3.111a7 7 0 0 1 1.932-1.932M.133 5.634a7 7 0 0 0 0 2.732l1.962-.388a5 5 0 0 1 0-1.956zm1.046 5.255 1.662-1.112a5 5 0 0 0 1.382 1.382l-1.112 1.662a7 7 0 0 1-1.932-1.932m4.455 2.978.388-1.962a5 5 0 0 0 1.956 0l.388 1.962a7 7 0 0 1-2.732 0m5.255-1.046-1.112-1.662a5 5 0 0 0 1.382-1.382l1.662 1.112a7 7 0 0 1-1.932 1.932"
    }, null, -1)
  ])))
}
export default { render: render }